jQuery(
  "#shopify-section-template--16900528636061__1709121414701147e8"
).appendTo(".banner-content");
jQuery(window).on("load", function () {
  jQuery(
    "#shopify-block-convermax_year_make_model_verify_fitment_3MqtN4"
  ).insertBefore(".product-form__buttons");
});

function openTab(tabId) {
  // Hide all tab contents
  var tabContents = document.getElementsByClassName("tab-content");
  for (var i = 0; i < tabContents.length; i++) {
    tabContents[i].style.display = "none";
  }

  // Remove 'active-tab' class from all tabs
  var tabs = document.getElementsByClassName("tab");
  for (var i = 0; i < tabs.length; i++) {
    tabs[i].classList.remove("active-tab");
  }

  // Show the selected tab content and mark it as active
  document.getElementById(tabId).style.display = "block";
  document
    .querySelector("[onclick=\"openTab('" + tabId + "')\"]")
    .classList.add("active-tab");
}

$(document).ready(function () {
  setTimeout(function () {
    jQuery(".verify-fitment-heading").on("click", function () {
      $(this).parent().addClass("open");
    });
    jQuery(".ymm-link").on("click", function () {
      $(".custom-ymm-form-body").addClass("open");
    });
  }, 3000);
  return false;
});

if ($('.product-form__submit:contains("Call for Availability")').length > 0) {
  $(".product-form__buttons").addClass("not-available");
}
// $(".loadLately").hide();
// $(document).ready(function () {
//   $(window).on("load", function () {
//     // Set a timeout to execute code after a specified delay (in milliseconds)
//     setTimeout(function () {
//       // Code to execute after the timeout
//       $(".loadLately").show();
//       $(".loadLately").html(
//         '<div class="elfsight-sapp-880eb013-6aa9-4fdf-9518-d2f7b25dd9d6"></div>'
//       );
//       // You can replace the console.log with any code you want to execute
//     }, 3000); // 3000 milliseconds = 3 seconds
//   });
// });

document.addEventListener("DOMContentLoaded", (event) => {
  // To load instagream section after sometime
  function lazyLoad() {
    const loadLately = document.querySelector(".loadLately");
    if (loadLately) {
      // Fallback to display the block after a maximum of 10 seconds
      const fallbackTimeout = setTimeout(function () {
        loadLately.style.display = "block";
      }, 10000); // 10000 milliseconds = 10 seconds

      // Try to load the content after 3 seconds
      setTimeout(function () {
        requestAnimationFrame(function () {
          loadLately.innerHTML =
            '<div class="elfsight-sapp-880eb013-6aa9-4fdf-9518-d2f7b25dd9d6"></div>';
          loadLately.style.display = "block";

          // Clear the fallback timeout if the content is loaded successfully
          clearTimeout(fallbackTimeout);
        });
      }, 4000); // 3000 milliseconds = 3 seconds
    }
  }

  window.addEventListener("load", lazyLoad);

  // To add attribute in image
  // Get all images on the page
  const images = document.querySelectorAll("img");
  if (images) {
    images.forEach((img) => {
      // Check if the image doesn't have an alt attribute
      if (!img.getAttribute("alt")) {
        img.setAttribute("alt", img.getAttribute("src"));
      }

      // Check if the image doesn't have a height attribute
      if (!img.hasAttribute("height")) {
        img.setAttribute("height", "");
      }

      // Check if the image doesn't have a width attribute
      if (!img.hasAttribute("width")) {
        img.setAttribute("width", "");
      }
    });
  }

  // get the links and add attributes
  const links = document.querySelectorAll(
    ".ssw-share-faves, .terms-link, .ssw-hide, .ssw-ask-friends-btn"
  );
  if (links) {
    links.forEach((link) => {
      link.setAttribute("aria-hidden", "true");
      link.setAttribute("aria-label", "hidden arai attributes");
    });
  }
});


$(document).on("click touchend", ".fancybox-container", function (e) {

  // DO NOT close on next/prev arrows
  if ($(e.target).closest(".fancybox-navigation").length) {
    return;
  }

  // DO NOT close on toolbar buttons
  if ($(e.target).closest(".fancybox-toolbar").length) {
    return;
  }

  // DO NOT close when clicking inside content
  if ($(e.target).closest(".fancybox-content").length) {
    return;
  }

  // Otherwise, click was outside → close
  $.fancybox.close();
});
